import { useEffect, useState } from 'react';
import { fetchApigenHealth } from '../api';
import type { ApigenHealth } from '../types';

const POLL_INTERVAL_MS = 5000;

/**
 * Hook for the apigen service's `/health` endpoint.
 *
 * Mirrors `useVideoHealth`, but note that apigen is a *separate process* rather
 * than a sub-app mounted inside lightning — so this is the only signal that
 * reflects whether the Gen API backend itself is reachable.
 */
export function useApigenHealth() {
  const [health, setHealth] = useState<ApigenHealth | null>(null);
  const [beLive, setBeLive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const data = await fetchApigenHealth();
        if (cancelled) return;
        setHealth(data);
        setBeLive(true);
      } catch {
        if (cancelled) return;
        setBeLive(false);
      }
    };
    tick();
    const id = window.setInterval(tick, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  return { health, beLive };
}
